import { useQuery } from '@tanstack/react-query';
import { AdminGlobalConfigurationRow } from 'components/AdminGlobalConfigurationForm';

import { api } from 'constants/api';
import { ApiResponse } from 'types/utils/api-response';

export type ApiGlobalConfigurationType = {
  channel_cost_ratio_sms: number;
  channel_cost_ratio_push: number;
  last_send_threshold_sms: number;
  last_send_threshold_push: number;
  last_purchase_threshold_sms: number;
  last_purchase_threshold_push: number;
  audience_exclude_all_channels: boolean;
};

export type ApiConfigurationResponseType = ApiGlobalConfigurationType;

export const useGetGlobalApiConfiguration = () => {
  return useQuery({
    queryKey: ['getGlobalApiConfiguration'],
    enabled: true,
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<ApiConfigurationResponseType>>(
        '/configuration/global'
      );

      return data?.data
        ? (Object.entries(data.data).map(([key, value]) => ({
            key,
            value: String(value),
          })) as AdminGlobalConfigurationRow[])
        : null;
    },
  });
};
